import Dinero from 'dinero.js';

export default function amount(value) {
  if (!value) return '';
  const amount = Dinero(value);
  const unit = amount.toUnit();
  return unit;
}
